export default {
    url: '/:versionId',
    template: `
    <ui-view></ui-view>
    <div>
        <div class="colholder">
            <div class="col col01 fixed">
                <p class="desc muted">
                    <span>{{ 'course.Version' | translate }}: <strong>{{ vm.courseVersion.name }}</strong></span></br>
                    <span>{{ 'version.Created' | translate }}: <strong>{{ vm.MomentService.formatTimeStamp(vm.courseVersion.createdAt) }}</strong> ({{ vm.courseVersion.creator.displayName }})</span>
                    </br>
                    <span ng-if="vm.courseVersion.updatedAt">
                        {{ 'version.Last modified' | translate }}: <strong>{{ vm.MomentService.formatTimeStamp(vm.courseVersion.updatedAt) }}</strong> ({{ vm.courseVersion.updater.displayName }})
                    </span></br>
                    <span ng-if="vm.duration">{{ 'training.Expected duration (h)' | translate }}: <strong>{{ vm.duration }}</strong></span>
                </p>
            </div>
            <div class="col col01 fixed">
                <courses-courses-actions-version
                    context="vm.context"
                    course-version="vm.courseVersion"
                />
            </div>
        </div>
    </div>
    `,
    resolve: {
        courseVersion (CourseVersionResource, $stateParams) {
            return CourseVersionResource.get({
                id: $stateParams.versionId,
                expand: 'courseTrainings,courseTrainings.scorm,courseTrainings.scormTrainings.scorm,courseTrainingI18ns,courseOccurrences,creator,updater' +
                    ',courseTrainingForms,courseVersionLicences,automatedPlanningGroups,courseTrainings.materials,' +
                    'courseTrainings.materials.languages,courseTrainings.materials.chapters.chapterI18ns,' +
                    'courseTrainings.materials.chapters.section.sectionI18ns,activeCourseSkills'
            }).$promise;
        }
    },
    abstract: true,
    controller ($state, $rootScope, $scope, course, courseVersion, MomentService, CourseVersionService, TokenService
    ) {
        this.$state = $state;
        this.course = course;
        this.courseVersion = courseVersion;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.context = 'edit';

        if (this.courseVersion.duration) {
            this.duration = CourseVersionService.getDuration(this.courseVersion.duration);
        }

        const listener = $rootScope.$on('version:reload', (event, version) => {
            this.courseVersion = version;
            if (this.courseVersion.duration) {
                this.duration = CourseVersionService.getDuration(this.courseVersion.duration);
            }
            else {
                this.duration = null;
            }
        });
        $scope.$on('$destroy', listener);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/version/edit/index.js